<template>
    <div class="mt-4">
        <h6 class="col-12 mb-3 text-uppercase text-center bg-light p-2">
            History
        </h6>
        <div class="d-flex flex-wrap mt-4">
            <div class="from-group col-12 table-responsive">
                <table
                    id="post-history-datatable"
                    class="table table-centered table-bordered text-center table-sm"
                >
                    <thead>
                        <tr>
                            <th>Number</th>
                            <th>Date</th>
                            <th>Details</th>
                        </tr>
                        <tr
                            v-for="(history, index) in orderedHistories"
                            :key="history.id"
                        >
                            <td>{{ index + 1 }}</td>
                            <td>{{ history.createdAt | formatDate }}</td>
                            <td class="text-left">
                                <div v-if="history.details.status">
                                    -{{ `Status: ${history.details.status}` }}
                                </div>
                                <div v-if="history.details.text">
                                    -{{ `Email text: ${history.details.text}` }}
                                </div>
                                <div v-if="history.details.reason">
                                    -{{ `Reason: ${history.details.reason}` }}
                                </div>
                                <div v-if="history.details.changed">
                                    -{{
                                        `Changed by : ${history.details.changed}`
                                    }}
                                </div>
                            </td>
                        </tr>
                    </thead>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        histories: {
            type: Array,
            required: true
        }
    },

    computed: {
        orderedHistories() {
            const histories = this.histories;

            return histories.sort((a, b) =>
                this.$dayjs(a.createdAt).isAfter(this.$dayjs(b.createdAt))
                    ? 1
                    : -1
            );
        }
    }
};
</script>
